// AUTO-GENERATED CODE, DO NOT EDIT!
/* eslint-disable */

import * as Types from "../../types";

import gql from "graphql-tag";
import { SuppliersSupplierDealFragmentDoc } from "../../Components/Suppliers/Suppliers.generated-types";
import { AllPropsEnquiryDetailsEventFragmentDoc } from "./EnquiryDetails/EnquiryDetails.generated-types";
import { AllPropsProposalCardProposalFragmentDoc } from "./ProposalCard/ProposalCard.generated-types";
import * as Urql from "urql";
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type AllProposalsEventQueryVariables = Types.Exact<{
  UUID: Types.Scalars["ID"];
}>;

export type AllProposalsEventQuery = {
  __typename?: "Query";
  getEventByUUID: {
    __typename?: "Event";
    UUID: string;
    status: Types.EventStatus;
    name: string;
    budget: number;
    currency: string;
    attendees: number;
    location: string;
    cateringNeeds?: string | null;
    additionalNotes?: string | null;
    fromDateTime: string;
    toDateTime: string;
    proposals: Array<{
      __typename?: "Proposal";
      UUID: string;
      attendees: number;
      currency: string;
      status: Types.ProposalStatus;
      baseCostTotal: number;
      space: {
        __typename?: "SelfServeSpace";
        spaceName?: string | null;
        spacePhotos?: Array<{
          __typename?: "SelfServeSpacePhoto";
          url?: string | null;
        }> | null;
        venue?: {
          __typename?: "SelfServeVenue";
          name?: string | null;
          nearestTransit?: {
            __typename?: "NearestTransit";
            station?: string | null;
            distanceKm?: number | null;
          } | null;
        } | null;
      };
    }>;
    supplierDeals?: Array<{
      __typename?: "SupplierDeal";
      ID: number;
      message?: string | null;
      cost?: number | null;
      currency: string;
      supplier: {
        __typename?: "Supplier";
        ID: number;
        name: string;
        type: Types.SupplierType;
      };
      attachments?: Array<{
        __typename?: "SupplierDealAttachment";
        ID: number;
        filename: string;
        URL: string;
      }> | null;
    }> | null;
    spaceFacilities?: Array<{
      __typename?: "SpaceFacility";
      id: number;
      name: string;
    }> | null;
  };
};

export type AllProposalsProposalFragment = {
  __typename?: "Proposal";
  UUID: string;
  attendees: number;
  currency: string;
  status: Types.ProposalStatus;
  baseCostTotal: number;
  space: {
    __typename?: "SelfServeSpace";
    spaceName?: string | null;
    spacePhotos?: Array<{
      __typename?: "SelfServeSpacePhoto";
      url?: string | null;
    }> | null;
    venue?: {
      __typename?: "SelfServeVenue";
      name?: string | null;
      nearestTransit?: {
        __typename?: "NearestTransit";
        station?: string | null;
        distanceKm?: number | null;
      } | null;
    } | null;
  };
};

export const AllProposalsProposalFragmentDoc = gql`
  fragment AllProposalsProposal on Proposal {
    ...AllPropsProposalCardProposal
  }
  ${AllPropsProposalCardProposalFragmentDoc}
`;
export const AllProposalsEventDocument = gql`
  query AllProposalsEvent($UUID: ID!) {
    getEventByUUID(UUID: $UUID) {
      UUID
      status
      proposals {
        ...AllProposalsProposal
      }
      supplierDeals {
        ...SuppliersSupplierDeal
      }
      ...AllPropsEnquiryDetailsEvent
    }
  }
  ${AllProposalsProposalFragmentDoc}
  ${SuppliersSupplierDealFragmentDoc}
  ${AllPropsEnquiryDetailsEventFragmentDoc}
`;

export function useAllProposalsEventQuery(
  options: Omit<Urql.UseQueryArgs<AllProposalsEventQueryVariables>, "query">
) {
  return Urql.useQuery<AllProposalsEventQuery, AllProposalsEventQueryVariables>(
    { query: AllProposalsEventDocument, ...options }
  );
}
